var _defs;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgVectors = function SvgVectors(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 179",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.004 66.0144L447.48 22.8887C374.042 15.7157 299.923 24.627 230.278 49.0027L156 75L20.1998 34.7392C-18.0793 23.3906 -56.5 52.0736 -56.5 91.9995C-56.5 125.092 -29.5922 151.876 3.49986 151.723L1340 145.545C1405.26 145.244 1458 92.2576 1458 27L1361.54 13.847C1294.52 4.70771 1226.35 9.04521 1161.03 26.605L1070.26 51.0041C1011.24 66.8711 949.835 71.956 889.004 66.0144Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1107.16 16.527L1424.12 87.3264C1441.58 91.2267 1454 106.722 1454 124.613C1454 145.784 1436.78 162.919 1415.61 162.819L61.9994 156.425C12.2257 156.19 -27.9996 115.774 -27.9996 66C71.7542 23.2484 182.995 15.3212 287.803 43.4954L310.285 49.5389C372.851 66.3577 438.056 71.0533 502.387 63.3727L957.895 8.98778C1007.72 3.03907 1058.19 5.58833 1107.16 16.527Z",
    fill: "url(#paint1_linear)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.735 50.6121L6.93801 87.6075C-16.3455 90.1057 -34 109.756 -34 133.173C-34 158.483 -13.4825 179 11.827 179H1385.45C1435.16 179 1475.45 138.706 1475.45 89L1485 14C1389.29 62.1754 1278.81 72.1991 1176 42L1146.98 55.3353C1060.72 94.9838 965.063 109.663 870.875 97.7074L512.083 52.1651C458.876 45.4114 405.063 44.8902 351.735 50.6121Z",
    fill: "url(#paint2_linear)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 716.5,
    y1: -15.9999,
    x2: 716.5,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 669.5,
    y1: -15.9999,
    x2: 669.5,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 663.741,
    y1: 0.0000605155,
    x2: 663.741,
    y2: 179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVectors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vectors.b215f459.svg";
export { ForwardRef as ReactComponent };